module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAINJREFUKFNjZICCeRv2X2NgYMhLCnDYy8DA+B8mDqIZEYoO/GZgZLjE+udvamyw03lkhXBF8zcc+M7AwMDOwPD/HMvff2nICpEU7f/GwMDIycDA+O////8XGP7/LU0Kct6HYt38DTBFYAf8/8/w/1xSgKMJDkV4TSLCTfM2EOE7fOEEAB1BUgoM4XgiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/triangle_close.png
// module id = ZLwC
// module chunks = 1